export enum COMMON_ROUTES {
    HELP_CENTER = '/help-center',
}
